// True only in Range mode (no duration) when the start instant is at/after the end instant.
// Mirrors the original inline guard in Home so equal times count as invalid (>=).
export function isInvalidTimeRange(startTime, endTime, duration) {
    return Boolean(startTime && endTime && !duration) && new Date(startTime) >= new Date(endTime);
}
